// import styled from "styled-components"

// import { useSelector, useDispatch } from "react-redux"
// import { useEffect } from "react"
// import { fetchMonthlyContributions, fetchBalanceSheet, getActiveUserCount } from "Features/api/api"


// import MonthlyContributions from "./ContributionsPayments"
// import { numberWithCommas } from "SharedFns/Functions"
// import Spinner from "SharedFns/SpinnerElement"
// import UserFinancialDocument from "documents/UserFinancialSummary"
// import Modal from "../../SharedFns/Modal"
// import { useState } from "react"
// import LoanForm from "./LoanForm"



// const Home=(props)=>{
    
//     const dispatch=useDispatch()
//     const currentDate= new Date()
//     const formattedDate= `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`
//     useEffect( ()=>{
//       dispatch( getActiveUserCount())
//         dispatch( fetchMonthlyContributions())
//         dispatch(fetchBalanceSheet(formattedDate))
        
//      },[dispatch])
//      const[isModalOpen, setIsModalOpen]=useState(false)

//     const username=useSelector(state=> state.userData.user?.user.username)
//     const user=useSelector(state=> state.userData.user?.user)
//     const isLoading=useSelector(state=>state.getbalanceSheet?.loading)
    
//     const balanceSheetData = useSelector(state => state.getbalanceSheet?.balanceSheetData.balance_sheet??[])
//     const users_shared_interest_data=useSelector(state => state.getbalanceSheet?.balanceSheetData?.users_shared_interest_data??[])
//     // const balanceSheetData = useSelector(state => state.getbalanceSheet?.balanceSheetData.balance_sheet??[]);
//     const interestReceivables=balanceSheetData.assets?.interest_receivable.balance
//     const retained_earnings=(-1*balanceSheetData.equities?.retained_earnings.balance).toFixed(2)
//     const userCount=useSelector(state => state.activeUsersCount?.users?.active_users_count)
    
//     const shared_earning= (parseFloat(retained_earnings/userCount)|| 0.00)*0.63
//     const bankBalancerAccount=useSelector(state => state.getbalanceSheet?.balanceSheetData?.exited_Member_income?.balance);
//     console.log(bankBalancerAccount)
//     const bankBalance= (balanceSheetData.assets?.bank.balance)  + (interestReceivables) 
//     const ismenutoggled = useSelector( state=> state.userData.isMenuToggled)
    
//     const contributions=useSelector( (state)=> state.getContributions.contributions?.monthly_contributions)??[]
//     const total_paid_contributions = parseFloat(useSelector(state => state.getContributions.contributions?.total_amount_paid)) || 0.00;
//     const cleared_users_balance= (total_paid_contributions + 0.00).toFixed(2)||0.00
//     const total_savings_and_profit = (total_paid_contributions + shared_earning).toFixed(2) || 0.00;
//     const filteredContributions=(Array.isArray(contributions))? contributions.filter( contribution=>{
//         const  contributionMonth=new Date(contribution.contribution_month)
//         return contributionMonth ; 
//         }).sort((a,b)=>{
//           return new Date(b.contribution_month)- new Date(a.contribution_month) }):[]
//    const latestContributions=filteredContributions[0]     
   
//  const latestAmount=  latestContributions?.amount_paid
//  const groupYear=latestContributions?.group_year
//  const handleSummary=(userId)=>{
     
//   setIsModalOpen(true)
 
//     // dispatch( adminActivateUser({user_id}))

//   }
  
//     return(
     
//         <Container>
   
//           <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
//                 {<UserFinancialDocument isLoading={isLoading} setIsModalOpen={setIsModalOpen} user={user} totalUserContributions={total_paid_contributions} balanceSheetData={balanceSheetData} users_shared_interest_data={users_shared_interest_data} userCount={userCount}  />}
//             </Modal> 
        
//            <Introduction ismenutoggled={ismenutoggled}>
//            <h1 > {username && `Welcome, ${username}`} </h1> 
//              <p> Below is your accounts information </p>
//            </Introduction>
            
           

//             <Accounts ismenutoggled={ismenutoggled}>
//                 <Individual ismenutoggled={ismenutoggled} onClick={() => handleSummary(user)}>
//                     <Balances>
//                     <p style={{marginLeft:'10px'}}>{username}'s Account</p> 
//                      <h1 style={{marginTop:'1px', marginLeft: '10px'}}>{(user.has_cleared || !user.is_active) ? numberWithCommas(cleared_users_balance) : numberWithCommas(total_savings_and_profit)} KES</h1>
//                     </Balances>
//                     <Narration ismenutoggled={ismenutoggled}>
//                         <Particulars>
//                           <div>
//                             {isLoading && <Spinner/>}
//                           </div>
//                         {latestContributions && (
//                              <h3>Upto: {latestContributions.group_year} <p> Amount: {numberWithCommas(latestAmount)}</p></h3>
                            
                           
                          
                          
                          
//                                        )}
//                         </Particulars>
//                         <p> Monthly.Savings</p>
//                     </Narration>
                    
//                 </Individual>
//                 {(!user.has_cleared && user.is_active) &&<Group>
//                  <Balances>                  
                 
                
//                  <p>Eye20 Group Account</p>
                 
//                  <h1> {bankBalance && numberWithCommas(bankBalance.toFixed(2))} KES </h1>
//                  </Balances>
//                  <Narration>
//                         <p> Eye20 Group.Savings</p> 
//                  </Narration> 
                 
//                 </Group>}
//             </Accounts>
           
//         </Container>
            
     

//     )
// }


// const Container=styled.div`

// display:flex;

// flex-direction:column;
// align-items:flex-start;
// overflow:hidden;
// margin-left: 70px;
// margin-right:0px;
// height:100%;
// width:100%;
// padding-right:0px;
// @media (max-width: 768px) {
//   margin-left:5px;
  
// }
// `
// const Introduction= styled.div`
// align-items:center;
// margin-left:20px;
// border-bottom: solid 1px #E2725B ;

// margin-bottom:30px;
// transition: width 0.3s ease-out;
// width:${props => props.ismenutoggled? '100%': '100%'};

// h1{
//     margin-top: 10px;
//     margin-bottom: 2px;
// }
// p{
//     margin-top: 2px;
//     align-items:center;
//     margin-left:auto;
  
// }
// @media (max-width:768px) {
//     margin-left: 10px;
//     padding-right:10px;
//     align-items:center;
//     }
//     h1{
//         font-size:14px;
//     }
//     p{
//         font-size:12px;
        
// }
// `




// // const Accounts=styled.div`
// // display:flex;
// // flex-direction: row;
// // align-items:flex-start;
// // justify-content: space-between;
// // margin-top: 15px;
// // margin-left:5px;
// // padding-left:10px;
// // height:40%;
// // transition: width 0.3s ease-out;
// // width:${props => props.ismenutoggled? '100%': '80%'};
// // border-bottom: solid 1px #E2725B ; 

// // @media (max-width: 768px) {
// //     display: flex;
// //     flex-direction:column;
// //     align-items:flex-start;
// //     border-bottom:none;
// //     transition: width 0.3s ease-out;
// //     width:${props => props.ismenutoggled? '110%': '110%'};
// //     margin-left: 0px;
// //     padding-left: 2px;
   
    
// // }
// // `
// // const Individual=styled.div`
// // margin-right: 2px;
// // display:flex;
// // flex-direction:column;
// // align-items:flex-start;
// // padding: 5px;
// // opacity:1;
// // box-shadow:rgb(0 0 0 /69%) 0px 26px 30px -10px, rgb(0 0 0 /73%) 0px 16px 10px -10px ;
// // transition: opacity  border 3s ease;
// // margin-left:0px;
// // background-color:#034694;
// // height: 60%;
// // width: 25%;
// // color:white;
// // cursor:pointer;
// // font-size:15px;
// // font-weight:bold;
// // border:none;
// // border-radius:5%;
// // width:${props => props.ismenutoggled? '30%': '30%'};
// // box-shadow:rgb(0 0 0 /69%) 0px 26px 30px -10px, rgb(0 0 0 /73%) 0px 16px 10px -10px ;


// // &:hover{
// // opacity:0.8;

// // border: solid 1px #f9f9f9;}

// // @media (max-width: 768px) {
// //     width: 50%;
    
  
// //     margin-top: 20px auto;
// //     margin-left:20px;
// //     margin-right:0px;
// //     transition: width 0.3s  ease-out;
// //     &:hover{
// //         width:70%;
// //     }
  
    
// // }


// // `

// // const Group=styled.div`
// // margin-right:auto;
// // margin-left: 2%;
// // display:flex;
// // flex-direction:column;
// // align-items:flex-start;
// // padding: 5px;
// // opacity:1;
// // box-shadow:rgb(0 0 0 /69%) 0px 26px 30px -10px, rgb(0 0 0 /73%) 0px 16px 10px -10px ;
// // transition: opacity  border 3s ease;
// // margin-left:50px;
// // background-color:#034694;
// // height: 60%;
// // width: 25%;
// // color:white;
// // cursor:pointer;
// // font-size:15px;
// // font-weight:bold;
// // border:none;
// // border-radius:5%;

// // width:${props => props.ismenutoggled? '30%': '30%'};

// // &:hover{
// // opacity:0.8;
// // border: solid 1px #f9f9f9;
// // }
// // @media (max-width: 768px) {
// //     width: 50%;
// //     margin: 20px auto;
// //     margin-left:20px;
// //     transition: width 0.3s  ease-out;
// //     &:hover{
// //         width:70%;}
    
// // }
// // `
// // const Balances=styled.div`
// // display: flex;
// // margin-left: 5px;
// // width: 70%;
// // height: 10%;
// // flex-direction:column;
// // flex-wrap: nowrap;
// // align-items:flex-start;
// // position:relative;
// // h1{
// //     margin-top: 1px;
// //     margin-left:5px;
// // }
// // p{
// //     margin-top: 2px;
// //     margin-left:7px;
// // }
// // @media (max-width: 768px) {
// //     width: 50%;
// //    h1 { font-size: 12px;

// //     }
// //     p{ font-size:10px;
// //        width: 100%; 
// //     }
// // }
// // `
// // const Narration=styled.div`
// // height:4%;
// // display:flex;
// // flex-direction:row; 
// // width: 100% ;
// // align-items:flex-start;
// // justify-content:space-between;

// // margin-bottom:2px;
// // padding-top: 100px;
// // /* padding-left: 18px; */

// // p{
// //     font-size: 10px;
// //     color:#f9f9f9;
// //     padding-bottom: 4px;
// // }
// // h3{
// //     font-size:9px;
// //     padding-left: 70px;
// //     padding-bottom: 2px;
// //     padding-top:4px;
// //     line-height:1px;
// //     margin-left: 5px;
// // }
// // @media (max-width: 768px) {
// //     padding-bottom:2px;
// //     margin-bottom: 20px;
// //     width:100%;
// //     height:4%;
// //     align-items:space-between ;
// //     margin-left:0px;
// //     p{ font-size:8px;}
// //     h3{
// //         margin-left: 2px;
// //         padding-left: 20px;
// //         flex-wrap:nowrap;
// //     }
// //     transition: width 0.3s ease-out;
// //     width:${props => props.ismenutoggled? '100%': '100%'};
// // }
// // `
// // const DateUpto=styled.span`
// // width:80%;
// // height: 80%;
// // display:flex;
// // position:relative;
// // flex-direction:row; 
// // margin-left: 50px;
// // padding-left:20px;
// // margin-bottom:5px;
// // align-items:flex-end;
// // h3{
// //     font-size:10px;
// //     padding-left: 70px;
// //     padding-bottom: 2px;
// //     padding-top:0px;
// //     line-height:1px;
// // }

// // `
// // const Particulars=styled.div`
// // display:flex;
// // flex-direction: column;
// // justify-content:flex-start;
// // align-items:center;
// // flex-wrap: nowrap;
// // margin-left: 2px;


// // .p{
// //     font-size: 10px;
// //     color:#f9f9f9;
// //     padding-bottom: 4px;
    
// // }
// // .h3{
// //     font-size:10px;
// //     padding-left: 70px;
// //     padding-bottom: 70px;
  
// //     line-height:px;
// //     margin-left: 1px;
// // }

// // `
// // export default Home
// const Accounts = styled.div`
//   display: flex;
//   flex-direction: row;
//   align-items: flex-start;
//   position: relative;
//   justify-content: space-between;
//   margin-top: 15px;
//   margin-left: 5px;
//   padding-left: 2px;
//   height: 40%;
//   transition: width 0.3s ease-out;
//   width: ${(props) => (props.ismenutoggled ? '100%' : '100%')};
//   border-bottom: solid 1px #e2725b;

//   @media (max-width: 768px) {
//     display: flex;
//     flex-direction: column;
//     align-items: flex-start;
//     height: 35%;
//     border-bottom: none;
//     transition: width 0.3s ease-out;
//     width: ${(props) => (props.ismenutoggled ? '100%' : '100%')};
//     margin-left: 0px;
//     padding-left: 0px;
//   }
// `;

// const Individual = styled.div`
//   margin-right: 2px;
//   display: flex;
//   flex-direction: column;
//   align-items: flex-start;
//   justify-content:flex-start;
//   padding: 2px;
//   opacity: 1;
//   box-shadow: rgb(0 0 0 / 69%) 0px 26px 30px -10px, rgb(0 0 0 / 73%) 0px 16px 10px -10px;
//   transition: opacity border 3s ease;
//   margin-left: 0px;
//   background-color: #034694;
//   height: 60%;
//   color: white;
//   cursor: pointer;
//   font-size: 15px;
//   font-weight: bold;
//   border: none;
//   border-radius: 5%;
//   width: ${(props) => (props.ismenutoggled ? '25%' : '25%')};
//   box-shadow: rgb(0 0 0 / 69%) 0px 26px 30px -10px, rgb(0 0 0 / 73%) 0px 16px 10px -10px;

//   &:hover {
//     opacity: 0.8;
//     border: solid 1px #f9f9f9;
//   }

//   @media (max-width: 768px) {
//     width: 65%;
//     height:43%;
//     margin-top: 20px auto;
//     margin-left: 20px;
//     margin-right: 0px;
//     transition: width 0.3s ease-out;
//     &:hover {
//       width: 70%;
//     }
//   }
// `;

// const Balances = styled.div`
//   display: flex;
  
//   flex-direction: column;
//   align-items: flex-start;
//   width: 70%;
//   margin-left: 2px;
//   height: 10%;

//   h1{
//     margin-top: 2px;
//     margin-left: 2px;
//   }
//   p {
//     margin-top: 2px;
//     margin-left: 2px;
    
//   }

//   @media (max-width: 768px) {
//     width: 50%;
//     margin-bottom: 5px;
//     margin-left:0px;
//     h1 {
//       font-size: 8px;
//     }
//     p {
//       font-size: 6px;
//     }
//   }
// `;




// const Narration = styled.div`
//   height: 4%;
//   display: flex;
//   flex-direction: row;
//   width: 100%;
//   align-items: flex-start;
//   justify-content: space-between;
//   margin-bottom: 3px;
//   padding-top: 100px;

//   p {
//     font-size: 10px;
//     color: #f9f9f9;
//     padding-bottom: 4px;
//   }

//   h3 {
//     font-size: 9px;
//     padding-left: 2px;  // Adjusted padding
//     padding-bottom: 2px;
//     padding-top: 4px;
//     line-height: 1px;
//     margin-left: 2px;
//     white-space: nowrap;  // Added property to prevent text from wrapping
//     overflow: hidden;  // Added property to hide any overflowing text
//     text-overflow: ellipsis;  // Added property for ellipsis when text overflows
//   }

//   @media (max-width: 768px) {
//     padding-bottom: 12px;
//     margin-bottom: 20px;
//     width: 100%;
//     height: 4%;
//     align-items: space-between;
//     margin-left: 0px;
//     padding-top: 50px;
//     p {
//       font-size: 8px;
//       padding-left:5px;
//     }
//     h3 {
//       margin-left: 2px;
//       padding-left: 2px;
//       flex-wrap: nowrap;
//     }
//     transition: width 0.3s ease-out;
//     width: ${props => (props.ismenutoggled ? '100%' : '100%')};
//   }
// `;


// const DateUpto = styled.span`
//   width: 80%;
//   height: 80%;
//   display: flex;
//   position: relative;
//   flex-direction: row;
//   margin-left: 50px;
//   padding-left: 20px;
//   margin-bottom: 5px;
//   align-items: flex-end;

//   h3 {
//     font-size: 10px;
//     padding-left: 70px;
//     padding-bottom: 2px;
//     padding-top: 0px;
//     line-height: 1px;
//   }
// `;

// const Particulars = styled.div`
//   display: flex;
//   flex-direction: column;
//   justify-content: flex-start;
//   align-items: flex-start;
//   flex-wrap: nowrap;
//   margin-left: 2px;
//   width:100%;

//   .p {
//     font-size: 10px;
//     color: #f9f9f9;
//     padding-bottom: 4px;
//   }

//   .h3 {
//     font-size: 10px;
//     padding-left: 70px;
//     padding-bottom: 70px;
//     line-height: px;
//     margin-left: 1px;
//   }
// `
// const Group=styled.div`
// margin-right:auto;

// margin-left: 2%;
// display:flex;
// flex-direction:column;
// align-items:flex-start;
// padding: 5px;
// opacity:1;
// box-shadow:rgb(0 0 0 /69%) 0px 26px 30px -10px, rgb(0 0 0 /73%) 0px 16px 10px -10px ;
// transition: opacity  border 3s ease;
// margin-left:50px;
// background-color:#034694;
// height: 60%;
// width: 25%;
// color:white;
// cursor:pointer;
// font-size:15px;
// font-weight:bold;
// border:none;
// border-radius:5%;

// width:${props => props.ismenutoggled? '25%': '25%'};

// &:hover{
// opacity:0.8;
// border: solid 1px #f9f9f9;
// }
// @media (max-width: 768px) {
//     width: 65%;
//     height:42%;
//     margin: 20px auto;
//     margin-left:20px;
//     transition: width 0.3s  ease-out;
//     &:hover{
//         width:70%;}
    
// }
// `

// export default Home;
import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
// import { numberWithCommas } from 'SharedFns/Functions';
import { numberWithCommas } from 'SharedFns/Functions';
import { fetchLoans, fetchUserFines } from 'Features/api/api';
import Modal from '../../SharedFns/Modal';

import UserFinancialDocument from 'components/documents/UserFinancialSummary';

const Home = () => {
  const dispatch=useDispatch();
  const formatAmount = (value) => numberWithCommas((Number(value) || 0).toFixed(2));

  useEffect(() => {
    dispatch(fetchLoans());
    dispatch(fetchUserFines());
  }, [dispatch]);
  
 const[isModalOpen, setIsModalOpen]=useState(false)
  const username = useSelector((state) => state.userData.user?.user?.username);
  const user = useSelector((state) => state.userData.user?.user ?? {});
  const userGroups = user?.user_groups ?? ['Member'];
  const contributions = useSelector((state) => state.getContributions.contributions?.monthly_contributions ?? []);
  const totalPaidContributions = parseFloat(useSelector((state) => state.getContributions.contributions?.total_amount_paid)) || 0;
  const clearedUserBalance = totalPaidContributions;
   const loans= useSelector( state => state.getLoans.loans?.loans ?? []);
  const balanceSheet = useSelector((state) => state.getbalanceSheet?.balanceSheetData?.balance_sheet ?? {});
  const userCount = useSelector((state) => state.activeUsersCount?.users?.active_users_count ?? 1);
  const contributionFineTotal = parseFloat(
    useSelector((state) => state.getAllContributions?.contributionFineTotal ?? 0.00)
  ) || 0;
  const otherFineTotal = parseFloat(
    useSelector((state) => state.getAllContributions?.otherFineTotal ?? 0.00)
  ) || 0;
  const interestReceivable = balanceSheet.assets?.interest_receivable?.balance ?? 0;
  const retainedEarnings = (-1 * (balanceSheet.equities?.retained_earnings?.balance ?? 0)).toFixed(2);
  
  const groupBankBalance = (balanceSheet.assets?.bank?.balance ?? 0) + interestReceivable;

  const filteredContributions = Array.isArray(contributions)
  ? contributions
      .filter((contribution) => new Date(contribution.contribution_month))
      .sort((a, b) => new Date(b.contribution_month) - new Date(a.contribution_month))
  : [];

  const filteredLoans = loans.filter(
    loan => loan.status === "active" || loan.status === "default" || loan.status === "written_off"
  );
  const isLoading=useSelector(state=>state.getbalanceSheet?.loading)
 const total_paid_contributions = parseFloat(useSelector(state => state.getContributions.contributions?.total_amount_paid)) || 0.00;
const latestContribution = filteredContributions[0];
const contributionDate = latestContribution?.contribution_month ? new Date(latestContribution.contribution_month) : null;
const latestAmount = latestContribution?.amount_paid ?? 0;
const groupYear = latestContribution?.group_year ?? '';
const balanceSheetData = useSelector(state => state.getbalanceSheet?.balanceSheetData.balance_sheet??[])
const users_shared_interest_data=useSelector(state => state.getbalanceSheet?.balanceSheetData?.users_shared_interest_data??[])
const overallSharedInterest = user.has_cleared 
    ? 0 
    : (balanceSheetData?.users_shared_interest_data 
        ? balanceSheetData.users_shared_interest_data 
        : (userCount > 0 ? (parseFloat(retainedEarnings) / userCount) : 0)
      ).toFixed(2)

const userSharedInterest = users_shared_interest_data?.find(
        (data) => data.user === user.id
      );
      
 // Convert balance to a number safely
      const balance = userSharedInterest ? parseFloat((-1 * userSharedInterest.balance??0.00).toFixed(2)) : 0.00;
      
      // Calculate actual shared interest, ensuring multiplication with numbers
      const actualSharedInterest = userSharedInterest 
        ? (balance * 0.63).toFixed(2) 
        : (overallSharedInterest * 0.63).toFixed(2);    
     const totalSavingsAndProfit = totalPaidContributions + Number(actualSharedInterest);
     const accountBalance = user?.has_cleared || !user?.is_active ? clearedUserBalance : totalSavingsAndProfit;
  const today = new Date();
  let monthsSinceLastContribution = 0;

  if (contributionDate) {
    const yearDiff = today.getFullYear() - contributionDate.getFullYear();
    const monthDiff = today.getMonth() - contributionDate.getMonth();
    monthsSinceLastContribution = yearDiff * 12 + monthDiff;
  }
   const handleSummary=(userId)=>{
     
  setIsModalOpen(true)
 
    // dispatch( adminActivateUser({user_id}))

  }
  const totalLoanBalance = filteredLoans.reduce((sum, loan) => {
    const balance = parseFloat(loan.current_balance);
    return sum + (isNaN(balance) ? 0 : balance);
  }, 0);
  
  const defaultedLoan = loans?.some(loan => loan.status?.toLowerCase() === 'default');

  return (
    <Wrapper>
       <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} title='User Financial Summary'>
                 {<UserFinancialDocument isLoading={isLoading} setIsModalOpen={setIsModalOpen} user={user} totalUserContributions={total_paid_contributions} balanceSheetData={balanceSheetData} users_shared_interest_data={users_shared_interest_data} userCount={userCount}  />}
             </Modal> 
        
      <ThreeColumnLayout>
        {/* LEFT – USER INFO */}
        <Panel>
          <SectionTitle>👤 User Info</SectionTitle>
          <InfoItem><strong>Username:</strong> {username}</InfoItem>
          <InfoItem><strong>Role:</strong> {userGroups.join(', ')}</InfoItem>
          <InfoItem><strong>Status:</strong> {user?.is_active ? 'Active' : 'Inactive'} / {user?.has_cleared ? 'Cleared' : 'Not Cleared'}</InfoItem>
        </Panel>

        {/* CENTER – ACCOUNT SUMMARY */}
        <MainPanel>
        <Card style={{cursor: "pointer"}}onClick={() => handleSummary(user)}>
  <h3>💼 {username}'s Account</h3>
  <h2>KES {formatAmount(accountBalance)}</h2>
  {latestContribution && (
    <div>
      <small>📅 Group Year: {groupYear}</small><br />
      <small>💰 Amount: KES {formatAmount(latestAmount)}</small>
    </div>
  )}
</Card>



          <Card>
            <h3>🏦 Group Savings</h3>
            <h2>KES {formatAmount(groupBankBalance)}</h2>
            <small> actual bank balance</small>
          </Card>
        </MainPanel>

        {/* RIGHT – RECAP & WARNINGS */}
        <Panel>
          <SectionTitle>📌 Recap & Alerts</SectionTitle>
          <InfoItem><strong>Loan Balance:</strong> KES {formatAmount(totalLoanBalance)}</InfoItem>

          <InfoItem>
            <strong>Last Contribution:</strong><br />
            {latestContribution ? (
    <div>
      <small>📅 Group Year: {groupYear}</small><br />
      <small>💰 Amount: KES {formatAmount(latestAmount)}</small>
    </div>
  ): "No Record"}
          </InfoItem>
          {/* <InfoItem>
  <h4>📢 Status</h4>
  {monthsSinceLastContribution > 0 && (
    <p>
      ⏳ Last contributed <strong>{monthsSinceLastContribution}</strong> month{monthsSinceLastContribution > 1 ? 's' : ''} ago
    </p>
  )}
  {fineAmount > 0 ? (
    <p style={{ color: 'red' }}>
      ⚠️ Fine imposed: <strong>KES {numberWithCommas(fineAmount)}</strong><br />
      Please update your contributions.
    </p>
  ) : (
    <p>✅ You're up to date with contributions.</p>
  )}
</InfoItem> */}
<InfoItem>
  <h4>📢 Status</h4>
  {monthsSinceLastContribution > 0 && (
    <p>
      ⏳ Last contributed <strong>{monthsSinceLastContribution}</strong> month{monthsSinceLastContribution > 1 ? 's' : ''} ago
    </p>
  )}

  {contributionFineTotal > 0 && (
    <p style={{ color: 'red' }}>
      ⚠️ Late Contribution Fines: <strong>KES {formatAmount(contributionFineTotal)}</strong><br />
      Please update your contributions.
    </p>
  )}

  {otherFineTotal > 0 && (
    <p style={{ color: '#b22222' }}>
      🚫 Other Fines: <strong>KES {formatAmount(otherFineTotal)}</strong><br />
      Please review your outstanding fines with the group leadership.
    </p>
  )}

  {contributionFineTotal === 0 && otherFineTotal === 0 && (
    <p>✅ You're up to date with your recorded fines.</p>
  )}
</InfoItem>


          {defaultedLoan && (
            <Warning>⚠️ You have a defaulted loan!</Warning>
          )}
          {/* {contributionOverdue && (
            <Warning>⚠️ Your last contribution was over 3 months ago. A KES 100 fine may apply.</Warning>
          )} */}
        </Panel>
      </ThreeColumnLayout>
    </Wrapper>
  );
};

export default Home;


const Wrapper = styled.div`
  width: 100%;
  padding: 25px;
  box-sizing: border-box;
`;

const ThreeColumnLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  gap: 20px;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

const Panel = styled.div`
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  border: 1px solid #eee;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
`;

const MainPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const Card = styled.div`
  background: #f9f9f9;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #ddd;
  box-shadow: 0 1px 6px rgba(0,0,0,0.04);

  h2 {
    margin-top: 10px;
    color: #034694;
  }

  small {
    color: #666;
  }
`;

const SectionTitle = styled.h4`
  margin-bottom: 15px;
  font-size: 1.1rem;
  color: #034694;
`;

const InfoItem = styled.p`
  font-size: 0.95rem;
  margin-bottom: 12px;
  color: #333;
`;

const Warning = styled.div`
  background: #ffe9e9;
  color: #b30000;
  border-left: 4px solid #b30000;
  padding: 10px;
  margin-top: 15px;
  font-size: 0.9rem;
  border-radius: 5px;
`;
